module.exports = __webpack_public_path__ + "static/media/10n.09b893ae.png";